import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { getCollectionListbyWalletAddress } from '../../../hooks/Collectionhook';
import { FaCirclePlus } from "react-icons/fa6";
import logo1 from "../../../assets/img/avatars/avatar_1.png";
import { loadNFTsForaCollection } from '../../../assets/Data/NFT';
import Modal from 'react-modal';
import { FaRegWindowClose } from 'react-icons/fa';
import { CreateAuction } from '../../../hooks/AuctionHook';
import { ethers } from 'ethers';
import { collectionABI } from '../../../config/ABIs/CollectionABI';
import { auction_contract_address } from '../../../config/BackendUrl';
import logo from "../../../assets/img/logos/dtoc-logo.png";
import { getUserByAddress } from '../../../hooks/User';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import StepProgressBar from 'react-step-progress';
import 'react-step-progress/dist/index.css';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};


// export default ChooseCollection;



const Auction = () => {

    useDocumentTitle(' Mint');
    const [nfts, setNfts] = useState([]);
    const [selectedNFT, setSelectedNFT] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [collection, setCollection] = useState([]);
    const walletAddress = localStorage.getItem("WalletAddress");
    const [toggle, setToggle] = useState(false);
    const [selectCollection, setSelectCollection] = useState(false);
    const [selectedCollection, setSelectedCollection] = useState(false)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const PROVIDER = useSelector((state) => state.valueFromHeader);
    const route = useNavigate();

    function openModal(data) {
        setIsOpen(true);
        setSelectedNFT(data);
    }

    function closeModal() {
        setIsOpen(false);
    }

    function openModal1() {
        setIsOpen1(true);
    }

    function closeModal1() {
        setIsOpen1(false);
    }

    useEffect(() => {
        GetCollection();
    }, [walletAddress])

    const GetCollection = async () => {
        await getCollectionListbyWalletAddress(walletAddress).then(async (data) => {
            if (data.status === 201) {
                const Collect = data.data
                const newArray = await Promise.all(Collect.map(async (item, i) => {
                    const updatedNFTs = await loadNFTsForaCollection(item.contractAddress);
                    if (updatedNFTs.length !== 0) {
                        const UpdateNFTData = updatedNFTs.map((value) => {
                            if (value.owner === item.ownerAddress) {
                                return value
                            }
                            else {
                                return null
                            }
                        })
                        const AvailableNFTArr = UpdateNFTData.filter((data => data !== null));
                        return { ...item, isActive: false, AvailableNFTArr: AvailableNFTArr }; // Update object at specific index
                    }
                    else {
                        return { ...item, isActive: false, AvailableNFTArr: [] }; // Update object at specific index

                    }
                }))
                setCollection(newArray.reverse())
            }
        })

    }


    const ChoosedCollection = async (data) => {
        setSelectedCollection(data);
        const updatedNFTs = await loadNFTsForaCollection(data.contractAddress);
        const updatedNFTsWithUserData = await Promise.all(
            updatedNFTs.map(async (nft) => {
                const userResponse = await getUserByAddress(nft.owner);
                if (nft.owner === data.ownerAddress) {
                    return { ...nft, ownerName: userResponse?.user?.name };
                }
                else {
                    return null
                }
            })
        );
        // Update the state with the new array
        const AvailableNFTArr = updatedNFTsWithUserData.filter((data => data !== null));
        setNfts(AvailableNFTArr);
        await checkisApproved(data);
    }

    const NFTAuction = () => {
        const date = new Date(endTime);
        const epoch = date.getTime() / 1000;
        const body = {
            collectionAddress: selectedCollection.contractAddress,
            tokenId: selectedNFT.tokenId,
            endTime: epoch
        };
        CreateAuction(body).then(async (data) => {
            const AuctionData = data.data;
            // const provider = new BrowserProvider(window.ethereum);
            // 5. Send Transaction
            const signer = await PROVIDER.getSigner(walletAddress);
            const sentTx = await signer.sendTransaction(AuctionData);
            const receipt = await sentTx.wait();
            if (receipt) {
                toast.success("Transaction successful !!!");
                setTimeout(() => {
                    route('/live-auctions');
                }, 2000);
            }
        }).catch(() => {
            toast.error("Transaction Failed !!!")
        })
    }

    const checkisApproved = async (collection) => {
        try {
            // const Provider = new BrowserProvider(window.ethereum);
            const wallet = await PROVIDER.getSigner();

            const contracts = new ethers.Contract(
                collection.contractAddress,
                collectionABI,
                wallet
            );

            const test = await contracts.isApprovedForAll(
                collection.ownerAddress,
                auction_contract_address
            );

            if (test === false) {
                openModal1()
            }
            else {
                setSelectCollection(true);
                setToggle(true);
            }
        } catch (error) {
            toast.error("Error calling function:", error);
        }
    };

    const checksetApproved = async () => {
        try {
            // const Provider = new BrowserProvider(window.ethereum);
            const wallet = await PROVIDER.getSigner();

            const contracts = new ethers.Contract(
                selectedCollection.contractAddress,
                collectionABI,
                wallet
            );

            const test = await contracts.setApprovalForAll(
                auction_contract_address,
                true
            );
            const receipt = await test.wait();
            if (receipt) {
                closeModal1();
                setSelectCollection(true);
                toggle(true);
            }
        } catch (error) {
            toast.error("Error calling function:", error);
        }
    };

    const handleError = (event) => {
        event.target.src = logo1;
    };


    
    const CheckAllowance = () => {
        return (
            <div className="container" >
                <div className="box in__upload mt-40 mb-120">
                  
                    <div className='m-4'>
                        <h4>
                            Are you want to Update Approval State ?
                        </h4>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                        <button className="btn btn-sm btn-primary" onClick={closeModal1}>No </button>
                        <button className="btn btn-sm btn-primary" onClick={checksetApproved}>Yes</button>
                    </div>
                </div>
            </div>
        )

    }

    const ChooseCollection = (props) => {

        return (
            <>
                <div className="container" >
                    <div className="box in__upload mt-40 mb-120">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group space-y-10">
                                        <div className="space-y-20">
                                            <div className='space-y-10 drop_ui'>
                                                <h2 className="variationInput ">Choose collection</h2>
                                                <div className="row">
                                                    {collection.map((val, i) => (
                                                        <>
                                                            <div onClick={() => ChoosedCollection(val)} className="col-xl-4 col-lg-4 col-md-6 col-sm-6" key={i}>
                                                                <div className="card__item four">
                                                                    <div className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                                        {/* <div className="creators space-x-10"> */}
                                                                        <div className="avatars space-x-3">
                                                                            {/* <Link to="profile"> */}
                                                                            <img
                                                                                src={val.logo}
                                                                                alt=""
                                                                                onError={handleError}
                                                                                className="avatar avatar-lg"
                                                                            />
                                                                            {/* </Link> */}
                                                                        </div>
                                                                        {/* </div> */}
                                                                        <div className='mx-3'>
                                                                            <h6 className="card_title">
                                                                                <div className="color_black">
                                                                                    {val.name}
                                                                                </div>
                                                                            </h6>
                                                                            <div className="card_footer d-block space-y-10">
                                                                                <div className="card_footer justify-content-between">
                                                                                    <span className="card_title">
                                                                                        {val.symbol}
                                                                                    </span>
                                                                                </div>

                                                                            </div>
                                                                            <div>
                                                                                <h5>Available NFT : <span className='text-primary'>{val.AvailableNFTArr.length}</span></h5>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </>
                                                    ))}
                                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                                        <div className="card__item four">
                                                            <Link to="/collectionAdd" className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                                {/* <div className="creators space-x-10"> */}
                                                                <div className="avatars space-x-3">
                                                                    <Link to="/collectionAdd">
                                                                        <FaCirclePlus color='black' size="65" />
                                                                    </Link>
                                                                </div>
                                                                {/* </div> */}
                                                                <div className='mx-3'>
                                                                    <h6 className="card_title">
                                                                        <Link className="color_black" to="/collectionAdd">
                                                                            Create
                                                                        </Link>
                                                                    </h6>
                                                                    <div className="card_footer d-block space-y-10">
                                                                        <div className="card_footer justify-content-between">
                                                                            <span className="card_title">
                                                                                ERC-721
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <Modal
                    show={modalIsOpen}
                    // onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    ariaHideApp={false}
                    contentLabel="Example Modal"
                >
                    <div className='d-flex align-items-center justify-content-between'>
                        {/* <div>
                             <img src={logo} style={{ width: "8rem" }} alt="" />
                         </div> */}
                        <h2>
                            Auction NFT
                        </h2>
                        <FaRegWindowClose onClick={closeModal} />
                    </div>
                    <div className="box in__upload mt-40 mb-40">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="left__part space-y-40 md:mb-20 upload_file">
                                    <div className="space-y-20">
                                        {/* <img
                         className="icon"
                         src={`img/icons/upload.svg`}
                         alt="upload"
                       /> */}
                                        {selectedNFT && (selectedNFT.type !== null ? (selectedNFT.type.split('/')[0] === "image" ?

                                            <div>
                                                <img src={selectedNFT.image} alt="" />
                                            </div>
                                            :
                                            <video
                                                //  poster={subTitle.poster}
                                                src={selectedNFT.image} autoPlay muted loop>
                                            </video>
                                        ) : null)
                                        }

                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group space-y-10">
                                    <div className="space-y-20">
                                        <div className='space-y-10 colleion_ui'>
                                            <span className="variationInput">Collection</span>

                                            <div className='colletion_ui_data'>
                                                <div className="d-flex flex-column flex-md-row p-2">
                                                    <div className={"isSelected_collection d-flex justify-content-start"}>
                                                        <img
                                                            src={selectedCollection.logo}
                                                            alt="Dtoc_icon"
                                                        />
                                                        {/* {selectedNFT && (selectedNFT.type !== null ? (selectedNFT.type.split('/')[0] === "image" ?
     
                                                             <div>
                                                                 <img src={selectedNFT.image} alt="" />
                                                             </div>
                                                             :
                                                             <video
                                                                 //  poster={subTitle.poster}
                                                                 src={selectedNFT.image} autoPlay muted loop>
                                                             </video>
                                                         ) : null)
                                                         } */}

                                                        <div>
                                                            <div>
                                                                <span className=" ml-10">

                                                                    {selectedCollection.name}
                                                                </span>

                                                            </div>
                                                            <div>
                                                                <p className=" ml-10">
                                                                    {selectedCollection.symbol}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            {/* } */}
                                        </div>
                                        {/* </div> */}
                                        <div className="space-y-10">
                                            <span className="nameInput">Title</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='title'
                                                value={selectedNFT && selectedNFT.title}
                                            //   onChange={handleChange}
                                            />
                                        </div>
                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                category
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='price'

                                                value={selectedNFT && selectedNFT.category}
                                            // onChange={handleChange}
                                            />
                                        </div>

                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                Description
                                                {/* <span className="color_text">(optional) </span> */}
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='desc'
                                                value={selectedNFT && selectedNFT.desc}
                                            //   onChange={handleChange}
                                            />
                                        </div>

                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                End Time
                                                {/* <span className="color_text">(optional) </span> */}
                                            </span>
                                            <input
                                                type="datetime-local"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='desc'
                                                onChange={(e) => setEndTime(e.target.value)}
                                            // value={selectedNFT && selectedNFT.desc}
                                            //   onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                        <button className="btn btn-sm btn-primary" onClick={closeModal}>No </button>
                        <button className="btn btn-sm btn-primary" onClick={() => NFTAuction()}>Auction</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={modalIsOpen1}
                    // onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal1}
                    ariaHideApp={false}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className='d-flex align-items-center justify-content-between'>
                        <div>
                            <img src={logo} style={{ width: "8rem" }} alt="" />
                        </div>
                        <FaRegWindowClose onClick={closeModal1} />
                    </div>
                    <div className='m-4'>
                        <h4>
                            Are you want to Update Approval State ?
                        </h4>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                        <button className="btn btn-sm btn-primary" onClick={closeModal1}>No </button>
                        <button className="btn btn-sm btn-primary" onClick={checksetApproved}>Yes</button>
                    </div>
                </Modal>

            </>
        );
    };

    const ChooseNFT = () =>{
        return (
            <>
                <div className="container" >
                    <div className="box in__upload mt-40 mb-120">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group space-y-10">
                                        <div className="space-y-20">
                                            <div className='space-y-10 drop_ui'>
                                                <h2 className="variationInput mb-40 ">Choose NFT For Auction from {selectedCollection.name} Collection</h2>
                                                {toggle ? <>
                                                    {nfts.length !== 0 ?
                                                        <div className="row">

                                                            {nfts.map((val, i) => (
                                                                <>
                                                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6" style={{ cursor: "pointer" }} key={i} onClick={() => openModal(val)}>
                                                                        <div className="card__item four">
                                                                            <div className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                                                {/* <div className="creators space-x-10"> */}
                                                                                <div className="avatars space-x-3">
                                                                                    {/* <Link to="profile"> */}
                                                                                    <img
                                                                                        src={val.image}
                                                                                        alt=""
                                                                                        onError={handleError}
                                                                                        className="avatar avatar-lg"
                                                                                    />
                                                                                    {/* </Link> */}
                                                                                </div>
                                                                                {/* </div> */}
                                                                                <div className='mx-3'>
                                                                                    <h6 className="card_title">
                                                                                        <div className="color_black">
                                                                                            {val.title}
                                                                                        </div>
                                                                                    </h6>
                                                                                    <div className="card_footer d-block space-y-10">
                                                                                        <div className="card_footer justify-content-between">
                                                                                            <span className="card_title">
                                                                                                {val.category}
                                                                                            </span>
                                                                                        </div>

                                                                                    </div>
                                                                                    <div>
                                                                                        <span className='text-primary'>{val.desc}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </>
                                                            ))}
                                                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                                                <div className="card__item four">
                                                                    <Link to="/upload" className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                                        {/* <div className="creators space-x-10"> */}
                                                                        <div className="avatars space-x-3">
                                                                            <Link to="/upload">
                                                                                <FaCirclePlus color='black' size="65" />
                                                                            </Link>
                                                                        </div>
                                                                        {/* </div> */}
                                                                        <div className='mx-3'>
                                                                            <h6 className="card_title">
                                                                                <Link className="color_black" to="/upload">
                                                                                    Create NFT
                                                                                </Link>
                                                                            </h6>
                                                                            <div className="card_footer d-block space-y-10">
                                                                                <div className="card_footer justify-content-between">
                                                                                    <span className="card_title">
                                                                                        ERC-721
                                                                                    </span>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : <h2>Loading...</h2>}
                                                </>
                                                    :
                                                    <div className="row">
                                                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                                            <div className="card__item four">
                                                                <Link to="/upload" className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                                    {/* <div className="creators space-x-10"> */}
                                                                    <div className="avatars space-x-3">
                                                                        <Link to="/upload">
                                                                            <FaCirclePlus color='black' size="65" />
                                                                        </Link>
                                                                    </div>
                                                                    {/* </div> */}
                                                                    <div className='mx-3'>
                                                                        <h6 className="card_title">
                                                                            <Link className="color_black" to="/upload">
                                                                                Create NFT
                                                                            </Link>
                                                                        </h6>
                                                                        <div className="card_footer d-block space-y-10">
                                                                            <div className="card_footer justify-content-between">
                                                                                <span className="card_title">
                                                                                    {selectedCollection.name}
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <Modal
                    show={modalIsOpen}
                    // onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    ariaHideApp={false}
                    contentLabel="Example Modal"
                >
                    <div className='d-flex align-items-center justify-content-between'>
                        {/* <div>
                             <img src={logo} style={{ width: "8rem" }} alt="" />
                         </div> */}
                        <h2>
                            Auction NFT
                        </h2>
                        <FaRegWindowClose onClick={closeModal} />
                    </div>
                    <div className="box in__upload mt-40 mb-40">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="left__part space-y-40 md:mb-20 upload_file">
                                    <div className="space-y-20">
                                        {/* <img
                         className="icon"
                         src={`img/icons/upload.svg`}
                         alt="upload"
                       /> */}
                                        {selectedNFT && (selectedNFT.type !== null ? (selectedNFT.type.split('/')[0] === "image" ?

                                            <div>
                                                <img src={selectedNFT.image} alt="" />
                                            </div>
                                            :
                                            <video
                                                //  poster={subTitle.poster}
                                                src={selectedNFT.image} autoPlay muted loop>
                                            </video>
                                        ) : null)
                                        }

                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group space-y-10">
                                    <div className="space-y-20">
                                        <div className='space-y-10 colleion_ui'>
                                            <span className="variationInput">Collection</span>

                                            <div className='colletion_ui_data'>
                                                <div className="d-flex flex-column flex-md-row p-2">
                                                    <div className={"isSelected_collection d-flex justify-content-start"}>
                                                        <img
                                                            src={selectedCollection.logo}
                                                            alt="Dtoc_icon"
                                                        />
                                                        {/* {selectedNFT && (selectedNFT.type !== null ? (selectedNFT.type.split('/')[0] === "image" ?
     
                                                             <div>
                                                                 <img src={selectedNFT.image} alt="" />
                                                             </div>
                                                             :
                                                             <video
                                                                 //  poster={subTitle.poster}
                                                                 src={selectedNFT.image} autoPlay muted loop>
                                                             </video>
                                                         ) : null)
                                                         } */}

                                                        <div>
                                                            <div>
                                                                <span className=" ml-10">

                                                                    {selectedCollection.name}
                                                                </span>

                                                            </div>
                                                            <div>
                                                                <p className=" ml-10">
                                                                    {selectedCollection.symbol}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            {/* } */}
                                        </div>
                                        {/* </div> */}
                                        <div className="space-y-10">
                                            <span className="nameInput">Title</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='title'
                                                value={selectedNFT && selectedNFT.title}
                                            //   onChange={handleChange}
                                            />
                                        </div>
                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                category
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='price'

                                                value={selectedNFT && selectedNFT.category}
                                            // onChange={handleChange}
                                            />
                                        </div>

                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                Description
                                                {/* <span className="color_text">(optional) </span> */}
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='desc'
                                                value={selectedNFT && selectedNFT.desc}
                                            //   onChange={handleChange}
                                            />
                                        </div>

                                        <div className="space-y-10">
                                            <span className="nameInput">
                                                End Time
                                                {/* <span className="color_text">(optional) </span> */}
                                            </span>
                                            <input
                                                type="datetime-local"
                                                className="form-control"
                                                placeholder="e. g. `Dtoc design art`"
                                                name='desc'
                                                onChange={(e) => setEndTime(e.target.value)}
                                            // value={selectedNFT && selectedNFT.desc}
                                            //   onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                        <button className="btn btn-sm btn-primary" onClick={closeModal}>No </button>
                        <button className="btn btn-sm btn-primary" onClick={() => NFTAuction()}>Auction</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={modalIsOpen1}
                    // onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal1}
                    ariaHideApp={false}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className='d-flex align-items-center justify-content-between'>
                        <div>
                            <img src={logo} style={{ width: "8rem" }} alt="" />
                        </div>
                        <FaRegWindowClose onClick={closeModal1} />
                    </div>
                    <div className='m-4'>
                        <h4>
                            Are you want to Update Approval State ?
                        </h4>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                        <button className="btn btn-sm btn-primary" onClick={closeModal1}>No </button>
                        <button className="btn btn-sm btn-primary" onClick={checksetApproved}>Yes</button>
                    </div>
                </Modal>

            </>
        );
    }

    const step1Content = <ChooseCollection />;
    const step2Content = <CheckAllowance />;
    const step3Content = <ChooseNFT/>;

    // setup step validators, will be called before proceeding to the next step
    function step1Validator() {
        // return a boolean
        if(selectCollection){
            return true;
        }
        else{
            return false;
        }
    }
    
    function step2Validator() {
        // return a boolean
        return true;

    }

    function step3Validator() {
        // return a boolean
        return true;
    }

    function onFormSubmit() {
        // handle the submit logic here
        // This function will be executed at the last step
        // when the submit button (next button in the previous steps) is pressed
    }

    return (
        <StepProgressBar
            startingStep={0}
            onSubmit={onFormSubmit}
            steps={[
                {
                    label: 'Choose Collection',
                    subtitle: `${selectCollection ? selectedCollection.name : ""}`,
                    name: 'step 1',
                    content: step1Content,
                    validator: step1Validator

                },
                {
                    label: 'Allowance',
                    // subtitle: '50%',/
                    name: 'step 2',
                    content: step2Content,
                    validator: step2Validator
                },
                {
                    label: 'Choose NFTs',
                    // subtitle: '100%',
                    name: 'step 3',
                    content: step3Content,
                    validator: step3Validator
                },
                {
                    label: 'Confirm',
                    // subtitle: '100%',
                    name: 'step 3',
                    content: step3Content,
                    validator: step3Validator
                }
            ]}
        />
    )
}
export default Auction;